// GENERATED by `npm run icons:sync` — do not edit by hand.
import { createLucideIcon } from 'lucide-react';

export const Play = /*#__PURE__*/ createLucideIcon('Play', [ ["polygon", { points: "5 3 19 12 5 21 5 3", key: "191637" }] ]);
